var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 557,
    viewBox: "0 0 793 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M653.961 386.928C545.095 579.843 290.203 569.773 133.269 540.222C-23.6655 510.672 -12.2735 404.341 20.7047 229.204C53.6829 54.0663 555.07 -22.4419 712.005 7.10876C868.939 36.6594 768.317 184.286 653.961 386.928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseWhite);
export default __webpack_public_path__ + "static/media/Ellipse_white.7dd73663db8643b2bb2cdd60cc87ff8d.svg";
export { ForwardRef as ReactComponent };